import React from 'react';
import styled from 'styled-components';
import {tokensForThemeProvider} from '@forecast-it/design-system';

// Shared bookmark glyph used by both the agent chat ("Your Saved Prompts") and the AI report
// builder ("Save Report"). Lives here (not under either feature) so neither imports across
// feature boundaries. The DS icon set has no bookmark glyph, hence this custom mask.

/** the design bookmark glyph — mask shape only; color comes from background-color. */
const BOOKMARK_MASK = `url("data:image/svg+xml,${encodeURIComponent(
	'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 15"><path fill="black" fill-rule="evenodd" clip-rule="evenodd" d="M1.66667 0H10C10.442 0 10.866 0.175595 11.1785 0.488155C11.4911 0.800716 11.6667 1.22464 11.6667 1.66667V15L5.83333 11.6667L0 15V1.66667C0 1.22464 0.175595 0.800716 0.488155 0.488155C0.800716 0.175595 1.22464 0 1.66667 0ZM1.66667 1.25C1.55616 1.25 1.45018 1.2939 1.37204 1.37204C1.2939 1.45018 1.25 1.55616 1.25 1.66667V12.8333L5.83333 10.25L10.4167 12.8333V1.66667C10.4167 1.55616 10.3728 1.45018 10.2946 1.37204C10.2165 1.2939 10.1105 1.25 10 1.25H1.66667Z"/></svg>'
)}")`;

const tokens = tokensForThemeProvider.sky.sys;

// Masked glyph fill: brand-blue when active, disabled grey otherwise.
export const BOOKMARK_COLOR_ACTIVE = tokens.color.iconfill.primary;
export const BOOKMARK_COLOR_DISABLED = tokens.color.iconfill.disabled;

const BookmarkMark = styled.span<{$color: string}>`
	display: inline-block;
	width: 12px;
	height: 15px;
	flex-shrink: 0;
	pointer-events: none;
	background-color: ${({$color}) => $color};
	mask-image: ${BOOKMARK_MASK};
	mask-size: contain;
	mask-repeat: no-repeat;
	mask-position: center;
	-webkit-mask-image: ${BOOKMARK_MASK};
	-webkit-mask-size: contain;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-position: center;
`;

type BookmarkIconProps = {
	color?: string;
};

export function BookmarkIcon({color = BOOKMARK_COLOR_DISABLED}: BookmarkIconProps): JSX.Element {
	return <BookmarkMark aria-hidden="true" $color={color} />;
}
